<template>
  <div>
    <slot v-if="hasError" name="error" v-bind:err="err" v-bind:vm="vm" v-bind:info="info">
      <div class="content">
        <TriangleAlert :size="120" class="tw:text-red-500"/>
        <h2>An unexpected error occurred.</h2>
        <p class="tw:mt-2">Please try reloading the page, or contacting <a href="mailto:platform@cacgroup.com">platform@cacgroup.com</a>.</p>
        <div class="buttons">
          <v-btn to="/" color="primary" variant="flat">Home</v-btn>
          <v-btn @click="refresh" color="primary" variant="flat">Reload</v-btn>
        </div>
      </div>
    </slot>
    <slot v-else></slot>
  </div>
</template>

<script>
import { Commit } from '@/store';
import { StoreMutationType } from '@/types/StoreMutationType';
import { mapState } from 'vuex';
import { TriangleAlert } from 'lucide-vue-next';
import * as Sentry from '@sentry/vue';

export default {
  name: 'ErrorBoundary',
  components: {
    TriangleAlert,
  },
  data: () => ({
    err: false,
    vm: null,
    info: null,
  }),
  computed: {
    ...mapState(['hasError']),
  },
  errorCaptured(err, vm, info) {
    console.error(err);
    this.err = err;
    this.vm = vm;
    this.info = info;
    Sentry.captureException(err);
    Commit(StoreMutationType.SET_HAS_ERROR, true);
    return false;
  },
  methods: {
    refresh() {
      location.reload();
    }
  }
};
</script>

<style scoped>
.content {
  display: grid;
  grid-template-columns: 0.4fr;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  height: 80vh;
}

.content > * {
  text-align: center;
}

h2 {
  margin-top: 1em;
}

.buttons {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 1rem;
}
</style>
